<div *ngIf="show">
  <div class="compact-menu" (mouseenter)="handleMenu()">
    <div class="icon logo">
      <img alt="Logo Itaú Trader" src="../../../../assets/img/trader_logo_branca.svg" aria-hidden="true">
    </div>
    
    <ng-container *ngFor="let page of menuItems">
      <div class="icon">
        <ids-icon class="ids-pl-s" size="M"> {{ page.icon }} </ids-icon>
      </div>
    </ng-container>

    <div class="spacer"></div>
    
    <div class="icon height-auto">
      <div class="username-icon">
        {{ userNameInitials }}
      </div>
    </div>

    <div class="icon loggout" (click)="exit()">
      <ids-icon class="ids-pl-s" size="S"> sair </ids-icon>
    </div>
  </div>
  
  <div class="wrapper" (mouseleave)="handleMenu()" [ngClass]="{'opened': menuOpened}">
    <div class="expanded-menu">

      <div class="sub-menu logo">
        <img src="../../../../assets/img/trader_logo_branca_completa.svg" alt="Logo Itaú Trader" aria-hidden="true">
      </div>

      <ol (mouseleave)="page.open_subpages = false" (mouseenter)="page.open_subpages = true" *ngFor="let page of menuItems">
        <li (click)="goToPage(page.path)" class="sub-menu" [ngClass]="{'clickable': page.path, 'closed': !page.open_subpages && hideSubpages}">
          <ids-icon class="ids-pl-s" size="M"> {{ page.icon }} </ids-icon>
          <span class="page-name"> {{ page.label }} </span>
        </li>
        <li class="subpage-wrapper" *ngIf="page.open_subpages || !hideSubpages">
          <div *ngFor="let subpage of page.sub_menus" (click)="goToPage(subpage.path)" class="subpages clickable">
            {{ subpage.title }}
          </div>
        </li>
      </ol>

      <div class="spacer"></div>

      <div class="sub-menu padding-bottom-8">
        <div class="username-icon">
          {{ userNameInitials }}
        </div>
        <span class="username">{{ userName }}</span>
      </div>
      <div id="exit" class="sub-menu clickable" (click)="exit()">
        <ids-icon class="ids-pl-s" size="S"> sair </ids-icon>
        <span class="loggout">Sair do Itaú Trader</span>
      </div>
    </div>
  </div>
</div>
